exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-star-rating-star[data-v-79b2ecfa]{display:inline-block}.vue-star-rating-pointer[data-v-79b2ecfa]{cursor:pointer}.vue-star-rating[data-v-79b2ecfa]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.vue-star-rating-inline[data-v-79b2ecfa]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.vue-star-rating-rating-text[data-v-79b2ecfa]{margin-left:7px}.vue-star-rating-rtl[data-v-79b2ecfa]{direction:rtl}.vue-star-rating-rtl .vue-star-rating-rating-text[data-v-79b2ecfa]{margin-right:10px;direction:rtl}.sr-only[data-v-79b2ecfa]{position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79b2ecfa","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-star-rating/src/star-rating.vue
// module id = 660
// module chunks = 0